import 'angular:locale/data:es-ES';
import 'angular:locale/data:pt-BR';
import 'angular:locale/data:de-DE';
import 'angular:locale/data:en-US';
import './projects/accounts/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
